// import router from '@/router/create'
// import store from '@/models/store'

import { up } from 'inquirer/lib/utils/readline'
import { update } from 'lodash'

/**
 * 必须采用全局router
 * 分开编译过程中，就会导致不同对象
 * 而dev环境下，是同步编译的，所以不出错
 */
const router = Wiz.router
const store = Wiz.store

/**
 * 注册应用路由
 * @param {Array} routes
 */
export const registerRoutes = (routes) => {
  // https://v3.router.vuejs.org/zh/api/#router-addroute
  if (!Array.isArray(routes)) return
  routes.forEach((r) => {
    router.addRoute(r)
  })
}

/**
 * 注册system路由，alias of registerRoutes
 * 路由不需要分组注册，菜单需要分组
 * @param {Array} routes
 */
export const registerSysRoutes = (routes) => {
  registerRoutes(routes)
}

/**
 * 更新菜单
 * @param storeType 常规菜单与系统菜单，store state
 * @param menus 需要更新的菜单
 * @returns {Promise<void>}
 */
const updateStoreMenus = async (storeType, menus) => {
  let menuList = store.getters[storeType] || []
  if (menus) {
    // menuList = _.uniqBy(menuList.concat(menus), 'index')
    // 修改数组连接顺序 方便把老数组去重
    menuList = _.uniqBy(menus.concat(menuList), 'index')
    await store.dispatch(storeType, menuList)
  }
}
const getFirstPage = (treeArr) => {
  if (treeArr.children && treeArr.children.length) {
    getFirstPage(treeArr.children[0])
  } else {
    store.dispatch('Auth/firstPage', treeArr.index)
  }
}
/**
 * 更新用于鉴权使用的内存菜单（不显示到页面）
 * @param storeType store state
 * @param menus 需要更新的菜单
 * @returns {Promise<void>}
 */
const updateStoreHasDetailPageMenu = async (storeType, menus) => {
  if (menus) {
    await store.dispatch(storeType, menus)
  }
  let hasDetailPageMenu = store.getters[storeType] || []
  if (menus) {
    hasDetailPageMenu = _.uniqBy(menus.concat(hasDetailPageMenu), 'index')
    // 为顶级菜单添加标记，方便后续使用
    _.forEach(hasDetailPageMenu, (item) => {
      item.isTopMenu = true
    })
    // 找出菜单的第一个页面
    if (hasDetailPageMenu.length) {
      getFirstPage(hasDetailPageMenu[0])
    }
    await store.dispatch(storeType, hasDetailPageMenu)
  }
}
/**
 * 注册菜单，按添加的顺序进行菜单添加
 * @param menus
 */
export const registerMenus = async (menus) => {
  await updateStoreHasDetailPageMenu('Auth/hasDetailPageMenu', menus)
  await updateStoreMenus('Auth/menuList', menus)
}

/**
 * 注册系统菜单；
 * 此菜单会放到 '系统管理' 的子菜单下
 * 约定：menu.index = '/System' 为系统管理菜单
 * @param menus
 */
export const registerSysMenus = async (menus) => {
  await updateStoreHasDetailPageMenu('Auth/hasDetailPageMenu', menus)
  await updateStoreMenus('Auth/systemMenuList', menus)
}

/**
 * 清理菜单store
 * 因 vuex-persistedstate menus.concat 导致数据重复
 * 在首次加载应该清理下,避免因刷新导致菜单重复添加
 */
export const clearMenus = async () => {
  await store.dispatch('Auth/menuList', [])
  await store.dispatch('Auth/systemMenuList', null)
}
